import OrdersTable from './orders-table';

export default OrdersTable;